import React, { useState } from 'react'
import Button1 from '../../form/Button1'
import TextInput from '../../form/TextInput'
import moment from 'moment'
import addChangeMessage from '../../../controllers/booking/postTicketing/change/addMessage'
import { enqueueSnackbar } from 'notistack'

export default function AddRemarkMessage({data:defData,close, callback}) {
    const [data,setData] = useState({
        message: '',
    })
    const [loading,setLoading] = useState(false);

    async function handleSubmit(ev) {
        ev?.preventDefault();
        setLoading(true);
        const res = await addChangeMessage(defData?._id,data)
        setLoading(false);
        if(res?.return) {
            setData({message: ''})
            enqueueSnackbar(res.msg,{variant: 'success'})
            callback && callback()
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    
  return (
    <div className='flex flex-col gap-4'>
        {/* <h5>What's missing?</h5> */}
        <div className="flex gap-2">
        <p>Re-issue Request Time: </p>
        <span>
            {moment(data?.updatedAt).format(
            "YYYY-MM-DD, HH:mm"
            )}
        </span>
        </div>
        <TextInput
        label="Remarks"
        multiline
        rows={5}
        // placeholder={'e.g. Phone number is required'}
        value={data?.message || ""}
        onChange={(ev) =>
            setData({
                message: ev.target.value,
            })
        }
        />
        <div className="flex justify-end items-center gap-4">
        <div>
            <Button1
            variant="outlined"
            className="btn-outlined flex-1"
            onClick={() => close && close()}
            >
            Cancel
            </Button1>
        </div>
        <Button1
            onClick={(ev) => handleSubmit(ev)}
            loading={loading}
        >
            Add Update
        </Button1>
        </div>      
    </div>
  )
}
